import { gql } from '@apollo/client';

const SAVE_COMMENTARY = gql`
  mutation SaveCommentary($orgId: Int!, $commentary: String!) {
    saveCommentary(orgId: $orgId, commentary: $commentary) {
      OrgId
      Commentary
    }
  }
`;

export default SAVE_COMMENTARY;
